import { USER_TYPE } from '@/typings/enums/USER_TYPE';
import BaseEntity from './BaseEntity';

export default class UserEntity<T extends IUserSelfInformationModel = IUserSelfInformationModel & { organizationUserId?: number }> extends BaseEntity<T> {

	get userId () { return this.state.id }
	get userType () { return this.state.userType as USER_TYPE }
	get firstName () { return this.state.firstName }
	get lastName () { return this.state.lastName }
	get authLogin () { return this.state.authLogin }
	get avatarId () { return this.state.avatarId }
	get status () { return this.state.status }
	get roleUsers () { return this.state.roleUsers }
	get personalInformationMobilePhone () { return this.state.personalInformationMobilePhone }
	get personalInformationMobilePhoneCountry () { return this.state.personalInformationMobilePhoneCountry }
	get name () {
		const result = [];
		if (this.firstName) result.push(this.firstName);
		if (this.lastName) result.push(this.lastName);
		return result.join(' ');
	}

	get readableUserType () {
		switch (this.userType) {
			case USER_TYPE.TempWorker:
				return 'tempWorker';
			case USER_TYPE.Agency:
				return 'agency';
			case USER_TYPE.Client:
				return 'client';
			default:
				return undefined;
		}
	}

	isClient (userType = this.userType): this is { userType: USER_TYPE.Client } {
		return userType === USER_TYPE.Client;
	}

	isAgency (userType = this.userType): this is { userType: USER_TYPE.Agency } {
		return userType === USER_TYPE.Agency;
	}

	isTempWorker (userType = this.userType): this is { userType: USER_TYPE.TempWorker } {
		return userType === USER_TYPE.TempWorker;
	}

	isCreator () {
		return !!this.roleUsers?.filter(x => x?.organizationRole?.name === 'Créateur').length;
	}

	addUserRole (role: IRoleUserDetailModel) {
		this.state?.roleUsers.push(role);
	}

	deleteUserRole (roleUserId: number) {
		this.state?.roleUsers.deleteWhere(x => x.id === roleUserId);
	}

}
